import { Auth0UserRecord } from '@/types';
import { DomainCode } from '@australiangreens/ag-internal-components';
import { logger } from '@/util';
import callBackendApi from './call';

export const getUsersContaining = async (
  token: string,
  containedString: string,
  abortSignal?: AbortSignal
) => {
  logger.debug('getUsersContaining() called', {});

  const data = await callBackendApi({
    token,
    method: 'get',
    endpoint: `/users/containing/${encodeURIComponent(containedString)}`,
    abortSignal,
  });
  return data as Auth0UserRecord[];
};

export const clearUserPermCache = async (
  token: string,
  domainCode: DomainCode,
  abortSignal?: AbortSignal
) => {
  logger.debug('clearUserPermCache() called', {});

  const data = await callBackendApi({
    token,
    method: 'post',
    endpoint: `/clearuserpermcaches/?domainCode=${domainCode}&advsearch=true&civiacl=true`,
    abortSignal,
  });

  logger.debug('clearUserPermCache() response', { data });
};

export const getUsersByIds = async (
  token: string,
  subs: string[],
  abortSignal?: AbortSignal
): Promise<Auth0UserRecord[]> => {
  logger.debug(`getUsersByIds() called: subs=${subs}`, {});

  const data = await callBackendApi({
    token,
    method: 'get',
    endpoint: `/users?ids=${encodeURIComponent(JSON.stringify(subs))}`,
    abortSignal,
  });

  return data;
};
